var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-sm"},[_vm._v("\n  © "+_vm._s(_vm.currentYear)+" Technovation. All Rights Reserved. Technovation is\n  a 501c3 nonprofit organization in the United States.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }